import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

export default class BoardsLoopsRoute extends Route {
	@service('model-manager/board-loops')
	declare mmBoardLoopsService: Service.ModelManager.BoardLoops;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};

		document.body.id = 'page-board-loops';

		promises.initialRequests = this.navigationService.initialRequestsPromise;

		promises.boardLoops = this.mmBoardLoopsService.requestBoardLoops();

		return hashSettled(promises);
	}
}
